const initState = {
  countryNationality: [],
  successFetching: false,
  errorFetching: false,
};

export default initState;
